import * as React from "react";
import { useTranslation } from "react-i18next";
import OverlayTrigger from "components/common/OverlayTrigger";
import { Button, ButtonToolbar } from "components/bootstrap";
import useLicenseValidityForSubject from "license/hooks/useLicenseValidityForSubject";
import { LICENSE_SUBJECTS } from "license/constants";
import usePermissions from "hooks/usePermissions";
import * as ReportPermissions from "report/ReportPermissions";
import CreateButton from "components/common/CreateButton";
const ReportsSubNav = () => {
  const { t } = useTranslation("enterprise_report");
  const {
    data: { valid: isValidLicense },
    isInitialLoading: isLoadingLicense
  } = useLicenseValidityForSubject(LICENSE_SUBJECTS.report);
  const { isPermitted } = usePermissions();
  const canCreate = isPermitted(ReportPermissions.create);
  return canCreate && /* @__PURE__ */ React.createElement(ButtonToolbar, null, isLoadingLicense || isValidLicense ? /* @__PURE__ */ React.createElement(CreateButton, { entityKey: "Report" }) : /* @__PURE__ */ React.createElement(OverlayTrigger, { overlay: t("reports_sub_nav.create_disabled"), placement: "top" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", className: "disabled" }, t("reports_sub_nav.create_report"))));
};
export default ReportsSubNav;
